export function TextField({
  label, value, onChange, mono, placeholder,
}: {
  label: string
  value: string
  onChange: (v: string) => void
  mono?: boolean
  placeholder?: string
}) {
  return (
    <label style={{ display: 'block', marginBottom: 14 }}>
      <div style={{ fontSize: 11, color: 'var(--text-tertiary)', marginBottom: 4 }}>{label}</div>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        className={mono ? 'mono' : undefined}
        style={inputStyle}
      />
    </label>
  )
}

export function TextAreaField({
  label, value, onChange, rows = 4, placeholder,
}: {
  label: string
  value: string
  onChange: (v: string) => void
  rows?: number
  placeholder?: string
}) {
  return (
    <label style={{ display: 'block', marginBottom: 14 }}>
      <div style={{ fontSize: 11, color: 'var(--text-tertiary)', marginBottom: 4 }}>{label}</div>
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={rows}
        style={{ ...inputStyle, resize: 'vertical', fontFamily: 'var(--font-mono)', fontSize: 13 }}
      />
    </label>
  )
}

export function SelectField({
  label, value, onChange, options,
}: {
  label: string
  value: string
  onChange: (v: string) => void
  options: string[]
}) {
  return (
    <label style={{ display: 'block', marginBottom: 14 }}>
      <div style={{ fontSize: 11, color: 'var(--text-tertiary)', marginBottom: 4 }}>{label}</div>
      <select value={value} onChange={(e) => onChange(e.target.value)} style={inputStyle}>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </label>
  )
}

export const inputStyle: React.CSSProperties = {
  width: '100%',
  background: 'var(--surface-raised)',
  border: '1px solid var(--border)',
  borderRadius: 'var(--radius-sm)',
  color: 'var(--text-primary)',
  fontSize: 14,
  padding: '8px 10px',
}

export function SaveBar({
  onSave, saving, result,
}: {
  onSave: () => void
  saving: boolean
  result: string | null
}) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 8 }}>
      <button
        onClick={onSave}
        disabled={saving}
        style={{
          background: 'var(--surface-raised)',
          border: '1px solid var(--border-strong)',
          color: 'var(--text-primary)',
          borderRadius: 'var(--radius-sm)',
          padding: '8px 16px',
          fontSize: 13,
          cursor: 'pointer',
        }}
      >
        {saving ? 'Guardando…' : 'Guardar'}
      </button>
      {result && <span style={{ fontSize: 13, color: 'var(--text-secondary)' }}>{result}</span>}
    </div>
  )
}
